import { createAjv } from "@jsonforms/core";
import { Modal } from "pepsico-ds";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import JsonFormsWrapper from "../jsonForms/jsonFormsWrapper/JsonFormsWrapper";
import "./confirmationModal.scss";

const uiSchemaReject = {
  type: "VerticalLayout",
  elements: [
    {
      type: "SimpleGroup",
      elements: [
        {
          type: "VerticalLayout",
          elements: [
            {
              type: "Control",
              scope: "#/properties/reason",
              component: "textarea",
            },
          ],
        },
      ],
    },
  ],
};

const jsonSchemaReject = {
  type: "object",
  properties: {
    reason: {
      type: "string",
      title: "Reason for rejection",
      allOf: [
        {
          transform: ["trim"],
        },
        {
          minLength: 1,
        },
      ],
    },
  },
  required: ["reason"],
};

const uiSchemaApprove = {
  type: "VerticalLayout",
  elements: [
    {
      type: "SimpleGroup",
      elements: [
        {
          type: "VerticalLayout",
          elements: [
            {
              type: "Control",
              scope: "#/properties/points",
              component: "textInput",
              label: "Points",
            },
            {
              type: "Control",
              scope: "#/properties/reason",
              component: "textarea",
              label: "Comments",
            },
          ],
        },
      ],
    },
  ],
};

const jsonSchemaApprove = {
  type: "object",
  properties: {
    reason: {
      type: "string",
      title: "Reason",
    },
    points: {
      type: "integer",
      title: "Points",
    },
  },
};

const ConfirmationModal = ({ showModal, onClose, title, onConfirm }) => {
  const [primaryButtonText, setPrimaryButtonText] = useState("Confirm");
  const [uiSchema, setUiSchema] = useState(null);
  const [jsonSchema, setJsonSchema] = useState(null);
  const [data, setData] = useState({});
  useEffect(() => {
    if (title === "Reject") {
      setPrimaryButtonText("Reject");
      setUiSchema(uiSchemaReject);
      setJsonSchema(jsonSchemaReject);
    } else {
      setPrimaryButtonText("Approve");
      setUiSchema(uiSchemaApprove);
      setJsonSchema(jsonSchemaApprove);
    }

    // Reset data when title changes
    setData({});
  }, [title]);

  const handleConfirm = () => {
    onConfirm(data);
  };

  const isButtonDisabled = useMemo(() => {
    if (!data) return true;
    const ajv = createAjv();
    if (!jsonSchema) return true;
    const validate = ajv.compile(jsonSchema);
    const valid = validate(data);
    if (!valid) {
      console.error(validate.errors);
      return true;
    }
    return false;
  }, [data, jsonSchema]);

  return (
    <Modal
      showModal={showModal}
      onCloseModal={onClose}
      primaryButtonProps={{
        size: "medium",
        text: primaryButtonText,
        variant: "primary",
        onClick: handleConfirm,
        disabled: isButtonDisabled,
      }}
      secondaryButtonProps={{
        size: "medium",
        text: "Cancel",
        variant: "secondary",
        onClick: onClose,
      }}
      showTertiaryButton={false}
      showLink={false}
      title={title}
    >
      {Object.keys(uiSchema || {}).length &&
        Object.keys(jsonSchema || {}).length && (
          <div className="pefornace-confirmation-modal">
            <JsonFormsWrapper
              jsonschema={jsonSchema}
              uischema={uiSchema}
              data={data}
              onChange={(updatedData) => setData(updatedData)}
            />
          </div>
        )}
    </Modal>
  );
};
ConfirmationModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationModal;
